import {generateRandomSafeBase64} from '@/common/helpers/utils/generateRandomBase64';

let tabSessionId: string | undefined;

/**
 * The function returns a unique identifier if the loaded application instance.
 * The identifier is generated only once o the page loads and lives to until the page reloads or closes.
 */
export function getTabSessionId() {
	if (tabSessionId) {
		return tabSessionId;
	}

	tabSessionId = generateRandomSafeBase64(12);
	return tabSessionId;
}
